// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IEmployeeOverridablePropertiesInfoDto
 */
export interface IEmployeeOverridablePropertiesInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    is_reimbursement_allowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    is_bill_pay_allowed?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    allowed_payment_methods?: Set<IEmployeeOverridablePropertiesInfoDtoAllowedPaymentMethodsEnum>;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    customer_service_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    customer_service_url_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    customer_service_url_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    customer_service_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    customer_service_is_enabled?: boolean;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    logo_info?: IOrganizationLogoDto;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    ai_confidence_level?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeOverridablePropertiesInfoDto
     */
    ai_adjudication?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeOverridablePropertiesInfoDtoAllowedPaymentMethodsEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IEmployeeOverridablePropertiesInfoDto interface.
 */
export function instanceOfIEmployeeOverridablePropertiesInfoDto(value: object): value is IEmployeeOverridablePropertiesInfoDto {
    return true;
}

export function IEmployeeOverridablePropertiesInfoDtoFromJSON(json: any): IEmployeeOverridablePropertiesInfoDto {
    return IEmployeeOverridablePropertiesInfoDtoFromJSONTyped(json, false);
}

export function IEmployeeOverridablePropertiesInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeOverridablePropertiesInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_reimbursement_allowed': json['is_reimbursement_allowed'] == null ? undefined : json['is_reimbursement_allowed'],
        'is_bill_pay_allowed': json['is_bill_pay_allowed'] == null ? undefined : json['is_bill_pay_allowed'],
        'allowed_payment_methods': json['allowed_payment_methods'] == null ? undefined : new Set(json['allowed_payment_methods']),
        'customer_service_number': json['customer_service_number'] == null ? undefined : json['customer_service_number'],
        'customer_service_url_name': json['customer_service_url_name'] == null ? undefined : json['customer_service_url_name'],
        'customer_service_url_link': json['customer_service_url_link'] == null ? undefined : json['customer_service_url_link'],
        'customer_service_email': json['customer_service_email'] == null ? undefined : json['customer_service_email'],
        'customer_service_is_enabled': json['customer_service_is_enabled'] == null ? undefined : json['customer_service_is_enabled'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
        'ai_confidence_level': json['ai_confidence_level'] == null ? undefined : json['ai_confidence_level'],
        'ai_adjudication': json['ai_adjudication'] == null ? undefined : json['ai_adjudication'],
    };
}

export function IEmployeeOverridablePropertiesInfoDtoToJSON(json: any): IEmployeeOverridablePropertiesInfoDto {
    return IEmployeeOverridablePropertiesInfoDtoToJSONTyped(json, false);
}

export function IEmployeeOverridablePropertiesInfoDtoToJSONTyped(value?: IEmployeeOverridablePropertiesInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_reimbursement_allowed': value['is_reimbursement_allowed'],
        'is_bill_pay_allowed': value['is_bill_pay_allowed'],
        'allowed_payment_methods': value['allowed_payment_methods'] == null ? undefined : Array.from(value['allowed_payment_methods'] as Set<any>),
        'customer_service_number': value['customer_service_number'],
        'customer_service_url_name': value['customer_service_url_name'],
        'customer_service_url_link': value['customer_service_url_link'],
        'customer_service_email': value['customer_service_email'],
        'customer_service_is_enabled': value['customer_service_is_enabled'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
        'ai_confidence_level': value['ai_confidence_level'],
        'ai_adjudication': value['ai_adjudication'],
    };
}

